<script setup lang="ts">

type Props = { count: number }
defineProps<Props>();

const model = defineModel<number>( { required: true } );

</script>

<template>

    <div class="absolute bottom-8 3xl:bottom-16 left-0 w-full flex items-center justify-center">
        <transition mode="out-in"
            enter-active-class="transition-all ease-out duration-300"
            enter-from-class="opacity-0 translate-y-16" 
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition-all ease-in duration-300"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-16">

            <IconButton 
                v-if="model < count - 1"
                name="chevron-right" 
                class="
                    text-3xl 3xl:text-6xl rotate-90 !w-auto !h-auto scale-[120%] 3xl:scale-[300%]
                    opacity-20 hover:opacity-50
                "
                @click="() => model++"
            />

            <Button 
                v-else
                variant="text"
                @click="() => model = 0">
                Start Again
            </Button>

        </transition>
    </div>

</template>